import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import { BaseButton, Tooltip, Variables } from '../base';
import { ClaimIdBadge } from './claim-id-badge';
import {
    entityBadgeBaseStyles,
    entityBadgeHoverStyles,
    entityBadgeTokens,
    entityBadgeActionButtonHoverStyles,
} from './entity-badge.styles';

export const ClaimBadge = styled(ClaimIdBadge)`
    margin-left: 8px;
    &:first-of-type {
        margin-left: 0;
    }
`;

export const Wrapper = styled.section`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
`;

export const ExpandButton = styled(BaseButton)`
    display: inline-flex;
    overflow: hidden;
    color: ${entityBadgeTokens.color};
    background: transparent;
    font: ${entityBadgeTokens.font};
`;

export const ExpandIcon = styled(Icon)`
    height: 16px;
    width: 16px;
    fill: currentColor;
`;

export const VisitTooltip = styled(Tooltip)`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 12px;
    cursor: pointer;
`;

export const ActionIcon = styled(Icon)`
    height: 16px;
    width: 16px;
    fill: currentColor;
`;

export const ActionButton = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    align-self: stretch;
    border-left: 1px solid ${entityBadgeTokens.border};
    padding: 0 8px;
`;

export const ActionTooltip = styled(Tooltip)`
    display: inline-flex;
    align-items: center;
    cursor: pointer;
`;

const BadgeHover = css`
    ${entityBadgeHoverStyles}

    &:hover {
        ${ActionButton} {
            ${entityBadgeActionButtonHoverStyles}
        }
    }
`;

const BadgeDisabled = css`
    cursor: default;
`;

export const Badge = styled.div<{ disabled?: boolean }>`
    ${entityBadgeBaseStyles}
    padding: 0;
    overflow: hidden;
    margin: 0;

    ${props => (props.disabled ? BadgeDisabled : BadgeHover)}
`;

export const ChevronIcon = styled(Icon, {
    shouldForwardProp: (prop) => prop !== 'rotated',
})<{ rotated: boolean }>`
    height: 16px;
    width: 16px;
    fill: currentColor;
    transition: transform 0.3s ease;
    transform: ${props => (props.rotated ? 'rotate(360deg)' : 'rotate(0deg)')};
`;

export const BundleText = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 0 12px;
    font: inherit;
    color: inherit;
`;

export const ClaimsContainer = styled.div<{ isExpanded: boolean }>`
    display: ${props => (props.isExpanded ? 'contents' : 'none')};
    opacity: ${props => (props.isExpanded ? '1' : '0')};
    transition: opacity 0.3s ease-in-out;
`;

export const ExpandableWrapper = styled.section<{ isExpanded: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 8px;
    column-gap: 8px;
    max-width: 100%;
`;

export const ClaimBadgeEnhanced = styled(ClaimIdBadge)`
    white-space: nowrap;
    flex-shrink: 0;
    margin: 0;

    &:first-of-type {
        margin-left: 0;
    }
`;
